'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { useMenus } from '../../../personly-libs-providers/src/index.js';
const MenuLinks = ({ children }) => {
    const { isOpen } = useMenus();
    const className = classnames({
        hidden: true,
        'flex-col': true,
        'lg:flex': true,
        '!flex': isOpen,
    });
    return _jsx("div", { className: className, children: children });
};
export default MenuLinks;
//# sourceMappingURL=index.js.map